import { MedicalHistory, MedicalHistoryControllerApi } from "../../../services";
import { useMutationWithLoading, getConfigObject } from "../../../utils/utils";

type Params = {
  medicalHistory: MedicalHistory;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const usePastMedicationHistoryUpdate = () =>
  useMutationWithLoading(async (params: Params) =>
    new MedicalHistoryControllerApi(
      getConfigObject()
    ).updatePatientMedicalHistory(params.medicalHistory, params.xTENANTID)
  );
